import RouletteEndBanner from '@/components/core/Games/RouletteEndBanner';
import FortuneDoubleRoulette from '@/components/FortuneDouble/Game/Content/Board/Roulette/Slider/Roulette';
import { Image } from '@starsoft/common/components';
import { GameReportBoardRound } from '../props';
import styles from './styles.module.scss';

export default function FortuneDoubleGameReportBoard({
  round,
}: GameReportBoardRound) {
  return (
    <div className={styles.container}>
      <div
        className={styles.container__display}
        style={{
          //@ts-ignore
          '--background-mobile-url': `url(${`${process.env.NEXT_PUBLIC_S3_BUCKET_BASE_URL}/artworks/fortune-double/backgrounds/board-mobile.png`})`,
          '--background-desktop-url': `url(${process.env.NEXT_PUBLIC_S3_BUCKET_BASE_URL}/artworks/fortune-double/backgrounds/board.png)`,
        }}
      >
        <div className={styles.container__bear}>
          <Image
            className={styles.container__bear__image}
            src={`${process.env.NEXT_PUBLIC_S3_BUCKET_BASE_URL}/artworks/fortune-double/bear.png`}
            alt="bear"
            width={300}
            height={300}
          />
        </div>
        <RouletteEndBanner
          isClosed={false}
          multiplier={round?.roulette?.tile?.multiplier?.toNumberString()}
        />
      </div>
      <FortuneDoubleRoulette round={round} spinningTime={0} />
    </div>
  );
}
